import { Pharmacy as AWPharmacy } from 'lib/amwell/sdk/types';
import { PharmacyType } from 'lib/amwell/sdk/enums';
import { State } from '../../system/types';

// Types
export type Pharmacy = AWPharmacy;

// Enums
export { PharmacyType };

export interface SearchCriteria {
  city: string;
  state: State;
  zipCode: string;
  pharmacyType: PharmacyType;
}

// Action Types
export interface GetAllPharmaciesPayload {
  latitude?: number;
  longitude?: number;
  pharmacyType: 'RETAIL' | 'MAIL_ORDERS';
  radius?: number;
}

export type SearchPharmaciesPayload = SearchCriteria;

export interface SetPharmacyPayload {
  pharmacy: Pharmacy;
}

export interface UpdatePharmacyPayload {
  pharmacy: Pharmacy;
}

export interface GetAllPharmaciesByInputPayload {
  input: string;
}
